import React from "react";

interface Props {
  fullName: string;
  textSize?: string;
}
const UserAvatar = ({ fullName, textSize = "text-3xl" }: Props) => {
  // Get initials from first and last name
  const getInitials = (fullName: string) => {
    const nameParts = fullName.split(' ').filter(part => part.length > 0 && part !== 'BINTI');
    const initials = nameParts
      .slice(0, 2) // Get only the first two parts
      .map(part => part.charAt(0).toUpperCase()) // Get the first letter of each part
      .join(''); // Join the initials together
    return initials;
  };

  const initials = getInitials(fullName);

  return (
    <div className="aspect-square relative w-full">
      <div
        className={`absolute inset-0 flex items-center justify-center rounded-full bg-gray-300 text-white`}
        title={`${fullName}`}
      >
        <span className={`font-medium text-black ${textSize}`}>{initials}</span>
      </div>
    </div>
  );
};

export default UserAvatar;
